// staffelkorting-redirect.js - Versie 12 - 08-10-2026
// v12: bewaakte uitzondering - webshopstaffel overslaan bij een geldig tabletticket voor precies dit product (zie geldigTabletTicket).
// Vorige: Versie 11 - 21-09-2026
// Hoort in: assets/staffelkorting-redirect.js
// Doorverwijzing naar kortingstrechter bij invullen 25+ stuks (of collectie-specifieke minimum)
// Werkt met Abode quantity-input web component (+/- knoppen en handmatig typen)
// v11: BUGFIX (21-09-2026) - "Logo of foto" en "Logo of foto + tekst" keken voor
// de uploadstatus en voor de logourl-parameter naar input#file-1. Dat native
// bestandsveld blijft na een Globo-upload altijd leeg (value === ""), dus het
// bevestigingsblok verscheen nooit en logourl was altijd leeg. Globo maakt pas
// na een geslaagde upload een apart, dynamisch hidden veld aan:
// input[name="properties[file-1]"], met de echte DigitalOceanSpaces-upload-URL
// als waarde - dat veld wordt nu overal gebruikt als bron voor heeftLogo en
// logourl. De zichtbare bestandsnaam in het bevestigingsblok komt nu uit
// Globo's eigen <span class="gpo-f-name">, met een terugval op de oude
// bestandsnaam()-functie als die span onverhoopt ontbreekt.
// vindInvoegPositie() gebruikt file-1 nog steeds, maar uitsluitend als
// DOM-ankerpunt om te bepalen waar het bevestigingsblok moet komen - dat staat
// los van de uploadstatus en is dus bewust ongewijzigd gelaten.
// Om het dynamische properties[file-1]-veld te detecteren zodra Globo het
// aanmaakt, is GEEN MutationObserver op het hele formulier gebruikt (dat
// veroorzaakte in v10 een oneindige lus doordat de observer ook de eigen
// invoeging van het bevestigingsblok zag). In plaats daarvan is het bestaande,
// al bewezen hertries-patroon van koppelPersonalisatieVelden() hergebruikt:
// een aparte, kleine setTimeout-lus (koppelLogoVeld) die elke 300ms controleert
// of properties[file-1] al bestaat, en pas een listener koppelt zodra dat zo is.
// De bestaande setInterval(evalueerStatus, 800) blijft daarnaast gewoon staan
// als vangnet, dus zelfs zonder deze listener wordt de status binnen 0,8
// seconde hoe dan ook opnieuw gecontroleerd.
// NOG NIET GETEST: het gedrag wanneer een klant een reeds geüpload bestand
// wijzigt of verwijdert nadat het bevestigingsblok al zichtbaar is (zie sectie
// 11 van het overdrachtsverslag van 21-09-2026) - dit moet nog apart worden
// getest voordat dit als volledig afgerond geldt.
//
// --- Geschiedenis (ongewijzigd overgenomen uit eerdere versies) ---
// v9: UX-AANPASSING (21-09-2026) - de automatische redirect zodra personalisatie
// compleet is, ging te snel voor de klant. In plaats daarvan verschijnt nu een
// rustig controle-/bevestigingsblok direct onder de personalisatievelden zodra
// de vereiste tekst/bestand is ingevuld, met een expliciete knop "BEVESTIGEN EN
// STAFFELKORTING BEKIJKEN". Pas na die bewuste klik gebeurt de redirect. Wijzigt
// de klant daarna nog iets (tekst wissen, ander bestand, andere personalisatie,
// aantal onder de drempel), dan wordt het blok direct bijgewerkt of verdwijnt
// het weer - de klant kan tot aan de klik alles gewoon blijven aanpassen.
// Producten zonder Personalisatie-optie: ongewijzigd automatisch gedrag (zoals
// voor v8), want daar valt niets te bevestigen.
// De parameteropbouw naar de kortingstrechter (handle/aantal/bereiding/
// personalisatie/logourl/logotekst) is 1-op-1 overgenomen uit v8, alleen de
// aanroep-timing is veranderd (nu via de bevestigingsknop i.p.v. automatisch).
// v8: BUGFIX (21-09-2026) - twee naam-mismatches gecorrigeerd die de automatische
// doorverwijzing lieten gebeuren voordat een klant een logo/foto had kunnen
// uploaden of tekst had kunnen invullen (kortingstrechter-1 heeft zelf geen
// uploadmogelijkheid). Personalisatie werd gelezen via een niet-bestaand
// select[name="options[Personalisatie]"] (het is een radio-groep
// input[name="Personalisatie"]) en het logobestand via een niet-bestaand
// input[name="properties[file-1]"] (het element heet gewoon file-1).
// v7: de "X-49 stuks - geen korting"-basisregel is verwijderd uit de getoonde
// staffeltabel (op verzoek) - de tabel toont nu alleen de echte kortingsschijven.
// v6: drie nette staffelkorting-types (gebak, logo, hartig/warm) met gedeelde
// tabel-opbouw, zodat de getoonde "Bekijk de staffelkorting" tabel altijd exact
// overeenkomt met de echte korting.

(function () {
var COLLECTIES = [
{
handle: "staffelkorting-gebak",
staffel: [
{ vanaf: 150, pct: 20 },
{ vanaf: 100, pct: 15 },
{ vanaf: 50, pct: 10 },
{ vanaf: 25, pct: 5 }
],
minimum: 25
},
{
handle: "staffelkorting-logo",
staffel: [
{ vanaf: 200, pct: 20 },
{ vanaf: 150, pct: 15 },
{ vanaf: 100, pct: 10 },
{ vanaf: 50, pct: 5 }
],
minimum: 25
},
{
handle: "staffelkorting-warm",
staffel: [
{ vanaf: 200, pct: 20 },
{ vanaf: 120, pct: 15 },
{ vanaf: 80, pct: 12.5 },
{ vanaf: 60, pct: 10 },
{ vanaf: 40, pct: 7.5 },
{ vanaf: 20, pct: 5 }
],
minimum: 20
},
{
handle: "minimum-20",
staffel: [
{ vanaf: 150, pct: 20 },
{ vanaf: 100, pct: 15 },
{ vanaf: 50, pct: 10 }
],
minimum: 50
}
];

function bouwStaffelTabelHTML(staffel, minimum) {
var rows = [];
for (var i = staffel.length - 1; i >= 0; i--) {
var s = staffel[i];
var volgende = i > 0 ? staffel[i - 1].vanaf : null;
var label = volgende ? (s.vanaf + "-" + (volgende - 1) + " stuks") : (s.vanaf + " stuks");
rows.push('<div style="padding:8px 0;border-bottom:1px solid rgba(134,106,71,0.15);">' + label + " - " + s.pct + "% korting</div>");
}
return rows.join("");
}

function updateStaffelAccordion(staffel, minimum) {
var accordion = document.querySelector(".jt-staffel-accordion");
if (!accordion) return;
var contentDiv = accordion.querySelector("div");
if (!contentDiv) return;
contentDiv.innerHTML = bouwStaffelTabelHTML(staffel, minimum);
}

var el = document.getElementById("staffel-data");
if (!el) return;
var productHandle = el.getAttribute("data-handle");
if (!productHandle) return;

// v12 (08-10-2026): bewaakte uitzondering voor de tablet (route a). De webshopstaffel (bevestigingsblok en
// doorverwijzing naar de kortingstrechter) wordt ALLEEN overgeslagen bij een geldig, niet-verlopen tabletticket
// voor precies dit product: ticket in sessionStorage van dit tabblad (gezet door de winkelmodule) met dezelfde
// geheime code als ?jullens_tablet=... in het adres, toestand "open", juiste handle en binnen 15 minuten.
// Een losse URL-parameter of een algemene tabletmarkering is onvoldoende. Zonder geldig ticket werkt alles
// precies als in v11. Korting op de tablet loopt uitsluitend via de backendcontrole (Vincent/Erica).
function geldigTabletTicket(handle) {
try {
var code = new URLSearchParams(window.location.search).get("jullens_tablet");
if (!code || !/^[0-9a-f]{16}$/.test(code)) return false;
var t = JSON.parse(window.sessionStorage.getItem("jullens_tablet_product") || "null");
if (!t || t.nonce !== code || t.toestand !== "open" || t.handle !== handle) return false;
var nu = Date.now();
if (!(typeof t.start === "number" && typeof t.verloopt === "number")) return false;
if (!(nu < t.verloopt) || (t.verloopt - t.start) > 15 * 60000 || t.start > nu + 60000) return false;
return true;
} catch (e) { return false; }
}
if (geldigTabletTicket(productHandle)) return;

var staffelMinimum = null;
var staffelTiers = null;

Promise.all(
COLLECTIES.map(function (c) {
return fetch("/collections/" + c.handle + "/products.json?limit=250")
.then(function (r) { return r.json(); })
.then(function (data) {
var handles = (data.products || []).map(function (p) { return p.handle; });
if (handles.indexOf(productHandle) !== -1) {
staffelMinimum = c.minimum;
staffelTiers = c.staffel;
}
})
.catch(function () {});
})
).then(function () {
if (staffelMinimum === null) return;

updateStaffelAccordion(staffelTiers, staffelMinimum);

function koppelEvents() {
var qtyInput = document.querySelector('input[name="quantity"]');
if (!qtyInput) return;

function personalisatieCompleet() {
var checked = document.querySelector('input[name="Personalisatie"]:checked');
if (!checked) return true;
var waarde = checked.value;
var logoEl = document.querySelector('input[name="properties[file-1]"]');
var tekstEl = document.getElementById("text-1");
var heeftLogo = !!(logoEl && logoEl.value);
var heeftTekst = !!(tekstEl && tekstEl.value && tekstEl.value.trim());
if (waarde === "Logo of foto") return heeftLogo;
if (waarde === "Alleen tekst") return heeftTekst;
if (waarde === "Logo of foto + tekst") return heeftLogo && heeftTekst;
return true;
}

function voerRedirectUit(qty) {
var bereidingInput = document.querySelector('input[name="Bereiding"]:checked');
var bereidingParam = bereidingInput ? ("&bereiding=" + encodeURIComponent(bereidingInput.value)) : "";

var personalisatieChecked = document.querySelector('input[name="Personalisatie"]:checked');
var personalisatieParam = personalisatieChecked ? ("&personalisatie=" + encodeURIComponent(personalisatieChecked.value)) : "";

var logoInput = document.querySelector('input[name="properties[file-1]"]');
var logoParam = (logoInput && logoInput.value) ? ("&logourl=" + encodeURIComponent(logoInput.value)) : "";

var tekstInput = document.getElementById("text-1");
var tekstParam = (tekstInput && tekstInput.value) ? ("&logotekst=" + encodeURIComponent(tekstInput.value)) : "";

window.location.href = "/pages/kortingstrechter-1?handle=" + productHandle + "&aantal=" + qty + bereidingParam + personalisatieParam + logoParam + tekstParam;
}

function bestandsnaam(pad) {
if (!pad) return "";
var delen = pad.split(/[\\\/]/);
return delen[delen.length - 1];
}

function logoBestandsnaam() {
var naam = document.querySelector(".gpo-f-name");
if (naam && naam.textContent && naam.textContent.trim()) return naam.textContent.trim();
var fileEl = document.getElementById("file-1");
return bestandsnaam(fileEl ? fileEl.value : "");
}

function verwijderBevestigingsblok() {
var bestaand = document.getElementById("jt-personalisatie-bevestiging");
if (bestaand) bestaand.parentNode.removeChild(bestaand);
}

function vindInvoegPositie() {
var tekstEl = document.getElementById("text-1");
var fileEl = document.getElementById("file-1");
var anchor = tekstEl || fileEl;
if (anchor) {
return anchor.closest(".gpo-options, .gpo-field, .gpo-wrapper") || anchor.parentElement;
}
var persRadios = document.querySelectorAll('input[name="Personalisatie"]');
if (persRadios.length) {
var last = persRadios[persRadios.length - 1];
return last.closest("fieldset, .product-form__input") || last.parentElement;
}
return null;
}

function escapeHtml(tekst) {
var div = document.createElement("div");
div.textContent = tekst || "";
return div.innerHTML;
}

function toonBevestigingsblok(qty) {
var checked = document.querySelector('input[name="Personalisatie"]:checked');
if (!checked) { verwijderBevestigingsblok(); return; }
var waarde = checked.value;
var tekstEl = document.getElementById("text-1");

var titel = "Controleer uw personalisatie";
var regels = "";

if (waarde === "Alleen tekst") {
regels = "<p style=" + String.fromCharCode(34) + "margin:0;" + String.fromCharCode(34) + ">U heeft ingevoerd: <strong>" + escapeHtml(tekstEl.value) + "</strong></p>";
} else if (waarde === "Logo of foto") {
titel = "Controleer uw gekozen bestand";
regels = "<p style=" + String.fromCharCode(34) + "margin:0;" + String.fromCharCode(34) + ">Gekozen bestand: <strong>" + escapeHtml(logoBestandsnaam()) + "</strong></p>";
} else if (waarde === "Logo of foto + tekst") {
regels = "<p style=" + String.fromCharCode(34) + "margin:0 0 0.4em;" + String.fromCharCode(34) + ">Gekozen bestand: <strong>" + escapeHtml(logoBestandsnaam()) + "</strong></p>" +
"<p style=" + String.fromCharCode(34) + "margin:0;" + String.fromCharCode(34) + ">Ingevoerde tekst: <strong>" + escapeHtml(tekstEl.value) + "</strong></p>";
}

var blok = document.getElementById("jt-personalisatie-bevestiging");
var nieuw = false;
if (!blok) {
blok = document.createElement("div");
blok.id = "jt-personalisatie-bevestiging";
blok.style.cssText = "margin-top:1em;padding:1em 1.2em;border:1px solid #866A47;border-radius:6px;background:rgba(134,106,71,0.06);";
nieuw = true;
}

blok.innerHTML =
"<p style=" + String.fromCharCode(34) + "margin:0 0 0.5em;font-weight:600;" + String.fromCharCode(34) + ">" + titel + "</p>" +
regels +
"<button type=" + String.fromCharCode(34) + "button" + String.fromCharCode(34) + " id=" + String.fromCharCode(34) + "jt-bevestig-btn" + String.fromCharCode(34) + " style=" + String.fromCharCode(34) + "margin-top:0.9em;width:100%;padding:0.8em 1em;background:#384F4A;color:#fff;border:none;border-radius:4px;font-weight:700;letter-spacing:0.02em;cursor:pointer;" + String.fromCharCode(34) + ">BEVESTIGEN EN STAFFELKORTING BEKIJKEN</button>";

var invoegPositie = vindInvoegPositie();
if (invoegPositie) {
invoegPositie.insertAdjacentElement("afterend", blok);
} else if (nieuw) {
qtyInput.parentElement.insertAdjacentElement("afterend", blok);
}

document.getElementById("jt-bevestig-btn").addEventListener("click", function () {
voerRedirectUit(qty);
});
}

function evalueerStatus() {
var qty = parseInt(qtyInput.value, 10);
var drempelBereikt = (!isNaN(qty) && qty >= (staffelMinimum - 3));

var checked = document.querySelector('input[name="Personalisatie"]:checked');

if (!checked) {
if (drempelBereikt) {
voerRedirectUit(qty);
}
return;
}

if (!drempelBereikt || !personalisatieCompleet()) {
verwijderBevestigingsblok();
return;
}

toonBevestigingsblok(qty);
}

qtyInput.addEventListener("change", evalueerStatus);

var observer = new MutationObserver(function () { evalueerStatus(); });
observer.observe(qtyInput, { attributes: true, attributeFilter: ["value"] });

var btnPlus = document.querySelector('.quantity__button[name="plus"]');
if (btnPlus) {
btnPlus.addEventListener("click", function () { setTimeout(evalueerStatus, 50); });
}

setInterval(evalueerStatus, 800);

var gekoppeldeVelden = { personalisatie: false, file: false, tekst: false };
function koppelPersonalisatieVelden() {
if (!gekoppeldeVelden.personalisatie) {
var persRadios = document.querySelectorAll('input[name="Personalisatie"]');
if (persRadios.length) {
persRadios.forEach(function (r) { r.addEventListener("change", evalueerStatus); });
gekoppeldeVelden.personalisatie = true;
}
}
if (!gekoppeldeVelden.file) {
var fileEl = document.getElementById("file-1");
if (fileEl) {
fileEl.addEventListener("change", evalueerStatus);
gekoppeldeVelden.file = true;
}
}
if (!gekoppeldeVelden.tekst) {
var tekstEl = document.getElementById("text-1");
if (tekstEl) {
tekstEl.addEventListener("input", evalueerStatus);
tekstEl.addEventListener("change", evalueerStatus);
gekoppeldeVelden.tekst = true;
}
}
if (!(gekoppeldeVelden.personalisatie && gekoppeldeVelden.file && gekoppeldeVelden.tekst)) {
setTimeout(koppelPersonalisatieVelden, 300);
}
}
koppelPersonalisatieVelden();

// v11: los, klein hertries-mechanisme specifiek voor het dynamische
// properties[file-1]-veld dat Globo pas ná een geslaagde upload aanmaakt.
// Zelfde bewezen patroon als koppelPersonalisatieVelden() hierboven, maar
// bewust gescheiden gehouden: dit veld bestaat vaak nog helemaal niet bij
// het laden van de pagina (pas na een klik + upload van de klant), dus deze
// lus mag - in tegenstelling tot koppelPersonalisatieVelden() - blijven
// doorpollen zolang de klant nog niets heeft geupload. Geen MutationObserver
// op het formulier nodig: de bestaande setInterval(evalueerStatus, 800)
// hierboven is sowieso al een permanent vangnet.
var logoVeldGekoppeld = false;
function koppelLogoVeld() {
if (logoVeldGekoppeld) return;
var logoEl = document.querySelector('input[name="properties[file-1]"]');
if (logoEl) {
logoEl.addEventListener("change", evalueerStatus);
logoVeldGekoppeld = true;
evalueerStatus();
return;
}
setTimeout(koppelLogoVeld, 300);
}
koppelLogoVeld();
}

if (document.querySelector('input[name="quantity"]')) {
koppelEvents();
} else {
setTimeout(koppelEvents, 500);
}
});
})();
// Versie 12 - 08-10-2026 - assets/staffelkorting-redirect.js - bewaakte tabletuitzondering; verder gelijk aan Versie 11
